import { Action } from '@ngrx/store';
import { createEntityReducer } from '../../../shared/base';
import { GetBuildingsByQueryCommand } from './building.commands';
import {
  CreatedBuildingEvent,
  GotAllBuildingsEvent,
  GotBuildingByIdEvent,
  GotBuildingsByQueryEvent,
  UpdatedBuildingEvent,
  UpdatedStatusBuildingEvent,
} from './building.events';
import { BuildingState } from './building.state';

export const buildingKey = 'building';
export const initialState: BuildingState = {
  entities: {},
  byQuery: {},
};

const entityReducer = createEntityReducer(
  initialState,
  CreatedBuildingEvent,
  GotAllBuildingsEvent,
  UpdatedBuildingEvent,
  UpdatedStatusBuildingEvent,
  GotBuildingByIdEvent,
  GotBuildingsByQueryEvent,
);

function isGetBuildingsByQueryCommand(
  action: Action,
): action is ReturnType<typeof GetBuildingsByQueryCommand> {
  return action.type === GetBuildingsByQueryCommand.type;
}

function isGotBuildingsByQueryEvent(
  action: Action,
): action is ReturnType<typeof GotBuildingsByQueryEvent> {
  return action.type === GotBuildingsByQueryEvent.type;
}

export function BuildingReducer(state: BuildingState | undefined, action: Action): BuildingState {
  const nextState = entityReducer(state, action);

  if (isGetBuildingsByQueryCommand(action)) {
    return {
      ...nextState,
      byQuery: {
        ...nextState.byQuery,
        [action.query]: undefined,
      },
    };
  }

  if (isGotBuildingsByQueryEvent(action)) {
    return {
      ...nextState,
      byQuery: {
        ...nextState.byQuery,
        [action.query]: action.entities.map((entity) => entity.id),
      },
    };
  }

  return nextState;
}
